// import React, { useState } from 'react';
// import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';

// export const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: ''
//   });
  
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   const contactInfo = [
//     {
//       icon: <Phone className="w-6 h-6 text-gold-500" />,
//       title: 'اتصل بنا',
//       details: ['+966', '+966']
//     },
//     {
//       icon: <Mail className="w-6 h-6 text-gold-500" />,
//       title: 'البريد الإلكتروني',
//       details: ['info@nrfirm.com', 'cs@nrfirm.com']
//     },
//     {
//       icon: <MapPin className="w-6 h-6 text-gold-500" />,
//       title: 'العنوان',
//       details: ['مركز الحمد الدور الثالث ',  'شارع البترجي  ']
//     },
//     {
//       icon: <Clock className="w-6 h-6 text-gold-500" />,
//       title: 'ساعات العمل',
//       details: ['الأحد - الخميس: 9:00 ص - 5:00 م', 'الجمعة والسبت: مغلق']
//     }
//   ];


// // const handleSubmit = async (e) => {
// //   e.preventDefault();
// //   setLoading(true);

// //   // Sanitize all fields
// //   const name = validator.escape(validator.trim(formData.name));
// //   const emailRaw = validator.trim(formData.email);
// //   const email = validator.normalizeEmail(emailRaw);
// //   const phone = validator.escape(validator.trim(formData.phone));
// //   const subject = validator.escape(validator.trim(formData.subject));
// //   const message = validator.escape(validator.trim(formData.message));

//   // Validate email
// //   if (!email || !validator.isEmail(email)) {
// //     alert('يرجى إدخال بريد إلكتروني صالح.');
// //     setLoading(false);
// //     return;
// //   }

// //   // Optional: validate name/message length
// //   if (name.length < 2 || message.length < 5) {
// //     alert('يرجى ملء جميع الحقول بشكل صحيح.');
// //     setLoading(false);
// //     return;
// //   }

// //   const { error } = await supabase
// //     .from('feedback')
// //     .insert([{ name, email, phone, subject, message }]);

// //   setLoading(false);

// //   if (error) {
// //     console.error('Submission error:', error.message);
// //     alert('حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة لاحقاً.');
// //     return;
// //   }

// //   alert('تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.');
// //   setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
// // };


  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//   };

//   return (
//     <section id="contact" className="py-20 bg-gray-100">
//       <div className="container mx-auto px-4 md:px-6">
//         <div 
//           ref={ref}
//           className={`text-center mb-16 transform transition-all duration-700 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">اتصل بنا</h2>
//           <div className="w-24 h-1 bg-gold-500 mx-auto mb-6"></div>
//           <p className="text-lg text-gray-700 max-w-3xl mx-auto">
//             نحن هنا للإجابة على استفساراتك وتقديم المساعدة القانونية التي تحتاجها
//           </p>
//         </div>
        
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           <div 
//             className={`bg-white rounded-lg shadow-card p-6 transform transition-all duration-700 delay-200 ${
//               inView ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
//             }`}
//           >
//             <h3 className="text-2xl font-bold text-navy-900 mb-6 text-center">معلومات التواصل</h3>
            
//             <div className="space-y-6">
//               {contactInfo.map((item, index) => (
//                 <div key={index} className="flex items-start">
//                   <div className="mt-1 ml-4 p-2 bg-navy-50 rounded-lg">
//                     {item.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-navy-900">{item.title}</h4>
//                     {item.details.map((detail, i) => (
//                       <p key={i} className="text-gray-700">{detail}</p>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <div className="mt-8 p-4 bg-navy-900 rounded-lg text-white">
//               <h4 className="font-bold text-gold-500 mb-2">استشارة أولية مجانية</h4>
//               <p className="text-sm">
//                 نقدم استشارة أولية مجانية لمدة 30 دقيقة لتقييم قضيتك. اتصل بنا لحجز موعدك.
//               </p>
//             </div>
//           </div>
          
//           <div 
//             className={`lg:col-span-2 bg-white rounded-lg shadow-card p-6 transform transition-all duration-700 delay-400 ${
//               inView ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
//             }`}
//           >
//             <h3 className="text-2xl font-bold text-navy-900 mb-6 text-center">أرسل لنا رسالة</h3>
            
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label htmlFor="name" className="block text-navy-900 font-medium mb-1">الاسم</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="email" className="block text-navy-900 font-medium mb-1">البريد الإلكتروني</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//               </div>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label htmlFor="phone" className="block text-navy-900 font-medium mb-1">رقم الهاتف</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="subject" className="block text-navy-900 font-medium mb-1">الموضوع</label>
//                   <input
//                     type="text"
//                     id="subject"
//                     name="subject"
//                     value={formData.subject}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//               </div>
              
//               <div>
//                 <label htmlFor="message" className="block text-navy-900 font-medium mb-1">الرسالة</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                   rows="5"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                 ></textarea>
//               </div>
              
//               <button
//                 type="submit"
//                 className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold py-3 px-6 rounded-lg transition-colors duration-300 inline-flex items-center justify-center w-full md:w-auto"
//               >
//                 إرسال الرسالة
//                 <Send className="mr-2 h-5 w-5" />
//               </button>
//             </form>
//           </div>
//         </div>
        
//         <div 
//           className={`mt-12 relative h-80 rounded-lg overflow-hidden shadow-card transform transition-all duration-700 delay-600 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <iframe
//            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3709.7048889747466!2d39.13463837521146!3d21.597439568004035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3dbf426e2ebf7%3A0x4b0b674c26d9de48!2z2LTYsdmD2Kkg2YbYp9i12LEg2KfZhNix2KfYrNit2Yog2Ygg2LHYp9mF2Yog2KfZhNmF2LfZitix2Yog2YTZhNmF2K3Yp9mF2KfYqQ!5e0!3m2!1sen!2ssa!4v1753085704389!5m2!1sen!2ssa" 
//             width="100%"
//             height="100%"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             title="office location"
//           ></iframe>
//         </div>
//       </div>
//     </section>
//   );
// };




// import React, { useState } from 'react';
// import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';
// import validator from 'validator';
// import { createClient } from '@supabase/supabase-js';
// import { supabase } from '../supabaseClient';
// // Initialize your Supabase client (replace with your keys)

// export const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: ''
//   });
//   const [loading, setLoading] = useState(false);

//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   const contactInfo = [
//     {
//       icon: <Phone className="w-6 h-6 text-gold-500" />,
//       title: 'اتصل بنا',
//       details: ['6161222(012)', '6161777(012)']
//     },
//     {
//       icon: <Mail className="w-6 h-6 text-gold-500" />,
//       title: 'البريد الإلكتروني',
//       details: ['info@nrfirm.com', 'cs@nrfirm.com']
//     },
//     {
//       icon: <MapPin className="w-6 h-6 text-gold-500" />,
//       title: 'العنوان',
//       details: [   'جدة' ,  'حي الزهرة'    ,  'شارع البترجي  ' ,  'مركز الحمد الدور الثالث '     ]
//     },
//     {
//       icon: <Clock className="w-6 h-6 text-gold-500" />,
//       title: 'ساعات العمل',
//       details: ['الأحد - الخميس: 9:00 ص - 5:00 م', 'الجمعة والسبت: مغلق']
//     }
//   ];

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Sanitize all fields
//     const name = validator.escape(validator.trim(formData.name));
//     const emailRaw = validator.trim(formData.email);
//     const email = validator.normalizeEmail(emailRaw);
//     const phone = validator.escape(validator.trim(formData.phone));
//     const subject = validator.escape(validator.trim(formData.subject));
//     const message = validator.escape(validator.trim(formData.message));

//     // Validate email
//     if (!email || !validator.isEmail(email)) {
//       alert('يرجى إدخال بريد إلكتروني صالح.');
//       setLoading(false);
//       return;
//     }

//     // Optional: validate minimum lengths
//     if (name.length < 2 || message.length < 5) {
//       alert('يرجى ملء جميع الحقول بشكل صحيح.');
//       setLoading(false);
//       return;
//     }

//     const { error } = await supabase
//       .from('emails')
//       .insert([{ name, email, phone, subject, message }]);

//     setLoading(false);

//     if (error) {
//       console.error('Submission error:', error.message);
//       alert('حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة لاحقاً.');
//       return;
//     }

//     alert('تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.');
//     setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
//   };

//   return (
//     <section id="contact" className="py-20 bg-gray-100">
//       <div className="container mx-auto px-4 md:px-6">
//         <div 
//           ref={ref}
//           className={`text-center mb-16 transform transition-all duration-700 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">اتصل بنا</h2>
//           <div className="w-24 h-1 bg-gold-500 mx-auto mb-6"></div>
//           <p className="text-lg text-gray-700 max-w-3xl mx-auto">
//             نحن هنا للإجابة على استفساراتك وتقديم المساعدة القانونية التي تحتاجها
//           </p>
//         </div>
        
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           <div 
//             className={`bg-white rounded-lg shadow-card p-6 transform transition-all duration-700 delay-200 ${
//               inView ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
//             }`}
//           >
//             <h3 className="text-2xl font-bold text-navy-900 mb-6 text-center">معلومات التواصل</h3>
            
//             <div className="space-y-6">
//               {contactInfo.map((item, index) => (
//                 <div key={index} className="flex items-start">
//                   <div className="mt-1 ml-4 p-2 bg-navy-50 rounded-lg">
//                     {item.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-navy-900">{item.title}</h4>
//                     {item.details.map((detail, i) => (
//                       <p key={i} className="text-gray-700">{detail}</p>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <div     onClick={() => {
//     window.open('https://wa.me/966595014100', '_blank')}}  className=" cursor-pointer mt-8 p-4 bg-navy-900 rounded-lg text-white hover:bg-white hover:text-navy-900">
//               <h4 className="font-bold text-gold-500 mb-2">استشارة أولية </h4>

//               <p className=' text-sm'>
//                                 نقدم بطلبك استشارة أولية     لتقييم قضيتك. اتصل بنا لحجز موعدك.

//               </p>
//             </div>
//           </div>
          
//           <div 
//             className={`lg:col-span-2 bg-white rounded-lg shadow-card p-6 transform transition-all duration-700 delay-400 ${
//               inView ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
//             }`}
//           >
//             <h3 className="text-2xl font-bold text-navy-900 mb-6 text-center">أرسل لنا رسالة</h3>
            
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label htmlFor="name" className="block text-navy-900 font-medium mb-1">الاسم</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="email" className="block text-navy-900 font-medium mb-1">البريد الإلكتروني</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//               </div>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label htmlFor="phone" className="block text-navy-900 font-medium mb-1">رقم الهاتف</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="subject" className="block text-navy-900 font-medium mb-1">الموضوع</label>
//                   <input
//                     type="text"
//                     id="subject"
//                     name="subject"
//                     value={formData.subject}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                   />
//                 </div>
//               </div>
              
//               <div>
//                 <label htmlFor="message" className="block text-navy-900 font-medium mb-1">الرسالة</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                   rows="5"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-gold-500 transition-colors duration-300"
//                 ></textarea>
//               </div>
              
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold py-3 px-6 rounded-lg transition-colors duration-300 inline-flex items-center justify-center w-full md:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 {loading ? 'جاري الإرسال...' : 'إرسال الرسالة'}
//                 <Send className="mr-2 h-5 w-5" />
//               </button>
//             </form>
//           </div>
//         </div>
        
//         <div 
//           className={`mt-12 relative h-80 rounded-lg overflow-hidden shadow-card transform transition-all duration-700 delay-600 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <iframe
//            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3709.7048889747466!2d39.13463837521146!3d21.597439568004035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3dbf426e2ebf7%3A0x4b0b674c26d9de48!2z2LTYsdmD2Kkg2YbYp9i12LEg2KfZhNix2KfYrNit2Yog2Ygg2LHYp9mF2Yog2KfZhNmF2LfZitix2Yog2YTZhNmF2K3Yp9mF2KfYqQ!5e0!3m2!1sen!2ssa!4v1753085704389!5m2!1sen!2ssa" 
//             width="100%"
//             height="100%"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             title="office location"
//           ></iframe>
//         </div>
//       </div>
//     </section>
//   );
// };








//    // <iframe
//    //         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3709.7048889747466!2d39.13463837521146!3d21.597439568004035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3dbf426e2ebf7%3A0x4b0b674c26d9de48!2z2LTYsdmD2Kkg2YbYp9i12LEg2KfZhNix2KfYrNit2Yog2Ygg2LHYp9mF2Yog2KfZhNmF2LfZitix2Yog2YTZhNmF2K3Yp9mF2KfYqQ!5e0!3m2!1sen!2ssa!4v1753085704389!5m2!1sen!2ssa" 
//    //          width="100%"
//    //          height="100%"
//    //          style={{ border: 0 }}
//    //          allowFullScreen=""
//    //          loading="lazy"
//    //          title="office location"
//    //        ></iframe>


// import React, { useState } from 'react';
// import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';
// import validator from 'validator';
// import { supabase } from '../supabaseClient';

// export const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: ''
//   });
//   const [loading, setLoading] = useState(false);

//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   const contactInfo = [
//     {
//       icon: <Phone className="w-5 h-5 text-amber-400" />,
//       title: 'اتصل بنا',
//       details: ['0126161222', '']
//     },
//     {
//       icon: <Mail className="w-5 h-5 text-amber-400" />,
//       title: 'البريد الإلكتروني',
//       details: ['info@nrfirm.com', 'cs@nrfirm.com']
//     },
//     {
//       icon: <MapPin className="w-5 h-5 text-amber-400" />,
//       title: 'العنوان',
//       details: ['جدة - حي الزهرة', 'شارع البترجي - مركز الحمد', 'الدور الثالث']
//     },
//     {
//       icon: <MapPin className="w-5 h-5 text-amber-400" />,
//       title: 'العنوان',
//       details: ['المدينة المنورة -  الدائري الثاني بجوار بنك الجزيرة']
//     },
//     {
//       icon: <Clock className="w-5 h-5 text-amber-400" />,
//       title: 'ساعات العمل',
//       details: ['الأحد - الخميس: 8:00 ص - 5:00 م', 'الجمعة والسبت: مغلق']
//     }
//   ];

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // تطهير البيانات المدخلة وحمايتها من الثغرات
//     const name = validator.escape(validator.trim(formData.name));
//     const emailRaw = validator.trim(formData.email);
//     const email = validator.normalizeEmail(emailRaw);
//     const phone = validator.escape(validator.trim(formData.phone));
//     const subject = validator.escape(validator.trim(formData.subject));
//     const message = validator.escape(validator.trim(formData.message));

//     if (!email || !validator.isEmail(email)) {
//       alert('يرجى إدخال بريد إلكتروني صالح.');
//       setLoading(false);
//       return;
//     }

//     if (name.length < 2 || message.length < 5) {
//       alert('يرجى ملء جميع الحقول بشكل صحيح.');
//       setLoading(false);
//       return;
//     }

//     const { error } = await supabase
//       .from('emails')
//       .insert([{ name, email, phone, subject, message }]);

//     setLoading(false);

//     if (error) {
//       console.error('Submission error:', error.message);
//       alert('حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة لاحقاً.');
//       return;
//     }

//     alert('تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.');
//     setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
//   };

//   return (
//     <section id="contact" className="py-24 bg-slate-900 border-b border-slate-800" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
//         {/* عنوان القسم */}
//         <div 
//           ref={ref}
//           className={`text-center mb-20 transform transition-all duration-1000 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
//             اتصل <span className="text-amber-400">بنا</span>
//           </h2>
//           <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-amber-300 mx-auto mb-6 rounded-full"></div>
//           <p className="text-base md:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
//             يسعدنا استقبال استفساراتكم القانونية وتقديم الدعم الوقائي والقضائي الذي يحمي مصالح أعمالكم.
//           </p>
//         </div>
        
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          
//           {/* الجانب الأيمن: بطاقات معلومات التواصل */}
//           <div 
//             className={`bg-slate-950/40 rounded-2xl border border-slate-800/80 p-8 transform transition-all duration-1000 delay-200 ${
//               inView ? 'translate-x-0 opacity-100' : 'translate-x-12 opacity-0'
//             }`}
//           >
//             <h3 className="text-2xl font-bold text-white mb-8 border-r-4 border-amber-500 pr-3">معلومات التواصل</h3>
            
//             <div className="space-y-8">
//               {contactInfo.map((item, index) => (
//                 <div key={index} className="flex items-start gap-4">
//                   <div className="p-2.5 bg-slate-900 border border-slate-800 rounded-xl shrink-0 text-amber-400">
//                     {item.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-white mb-1.5 text-base">{item.title}</h4>
//                     {item.details.map((detail, i) => (
//                       <p key={i} className="text-slate-400 text-sm md:text-base leading-relaxed font-light">{detail}</p>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             {/* بطاقة الاتصال المباشر بالواتساب للتواصل السريع الفوري */}
//             <div 
//               onClick={() => window.open('https://wa.me/966595014100', '_blank')}  
//               className="cursor-pointer mt-10 p-5 bg-gradient-to-br from-slate-900 to-slate-950 border border-amber-500/20 rounded-xl text-white hover:border-amber-500/40 transition-all duration-300 group shadow-lg"
//             >
//               <h4 className="font-bold text-amber-400 mb-2 group-hover:text-amber-300 transition-colors">طلب استشارة فورية</h4>
//               <p className="text-slate-400 text-xs md:text-sm leading-relaxed font-light">
//                 بإمكانكم حجز موعد لتقييم قضيتكم أو مراجعة عقودكم مباشرة عبر تطبيق الواتساب للتواصل الرسمي والمباشر.
//               </p>
//             </div>
//           </div>
          
//           {/* الجانب الأيسر: نموذج إرسال الرسائل وبناء قاعدة البيانات */}
//           <div 
//             className={`lg:col-span-2 bg-slate-950/40 rounded-2xl border border-slate-800/80 p-8 transform transition-all duration-1000 delay-400 ${
//               inView ? 'translate-x-0 opacity-100' : '-translate-x-12 opacity-0'
//             }`}
//           >
//             <h3 className="text-2xl font-bold text-white mb-8 border-r-4 border-amber-500 pr-3">أرسل لنا رسالة</h3>
            
//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label htmlFor="name" className="block text-slate-300 font-medium mb-2 text-sm">الاسم الكامل</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-300 text-sm"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="email" className="block text-slate-300 font-medium mb-2 text-sm">البريد الإلكتروني</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-300 text-sm"
//                   />
//                 </div>
//               </div>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label htmlFor="phone" className="block text-slate-300 font-medium mb-2 text-sm">رقم الجوال أو الهاتف</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-300 text-sm text-left"
//                     dir="ltr"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="subject" className="block text-slate-300 font-medium mb-2 text-sm">موضوع الاستشارة</label>
//                   <input
//                     type="text"
//                     id="subject"
//                     name="subject"
//                     value={formData.subject}
//                     onChange={handleChange}
//                     required
//                     className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-300 text-sm"
//                   />
//                 </div>
//               </div>
              
//               <div>
//                 <label htmlFor="message" className="block text-slate-300 font-medium mb-2 text-sm">تفاصيل الرسالة أو القضية</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                   rows="5"
//                   className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-300 text-sm resize-none"
//                 ></textarea>
//               </div>
              
//               <div className="flex justify-start">
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold py-3.5 px-8 rounded-xl transition-all duration-300 inline-flex items-center justify-center gap-2 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed text-base shadow-lg shadow-amber-500/5 hover:shadow-amber-500/10"
//                 >
//                   <span>{loading ? 'جاري إرسال البيانات...' : 'إرسال الرسالة القانونية'}</span>
//                   <Send className="h-4 w-4 transform rotate-180" />
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
        
//         {/* الخريطة التفاعلية للموقع الجغرافي للمكتب المهني بجدة */}
//         <div 
//           className={`mt-16 relative h-96 rounded-2xl overflow-hidden border border-slate-800/80 shadow-2xl transform transition-all duration-1000 delay-600 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <iframe
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3709.4344487431267!2d39.12328701168178!3d21.608020567223055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d10000000001%3A0x0!2zMjHCsDM2JzI4LjkiTiAzOcKwMDcnMzEuNiJF!5e0!3m2!1sar!2ssa!4v1700000000000!5m2!1sar!2ssa"
//             width="100%"
//             height="100%"
//             style={{ border: 0, filter: "grayscale(1) invert(0.9) contrast(1.2)" }}
//             allowFullScreen=""
//             loading="lazy"
//             title="موقع شركة ناصر الراجحي ورامي المطيري للمحاماة"
//           ></iframe>
//         </div>
//       </div>
//     </section>
//   );
// };




import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import validator from 'validator';
import { supabase } from '../supabaseClient';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const contactInfo = [
    {
      icon: <Phone className="w-5 h-5 text-indigo-950" />,
      title: 'اتصل بنا',
      details: ['0126161222', '']
    },
    {
      icon: <Mail className="w-5 h-5 text-indigo-950" />,
      title: 'البريد الإلكتروني',
      details: ['info@nrfirm.com', 'cs@nrfirm.com']
    },
    {
      icon: <MapPin className="w-5 h-5 text-indigo-950" />,
      title: 'العنوان',
      details: [ ' الفرع الرئيسي جدة - حي الزهراء  ', 'شارع البترجي - مركز الحمد']
    },
    {
      icon: <MapPin className="w-5 h-5 text-indigo-950" />,
      title: '',
      details: ['  فرع المدينة المنورة -  الدائري الثاني بجوار بنك الجزيرة  ']
    },
    {
      icon: <Clock className="w-5 h-5 text-indigo-950" />,
      title: 'ساعات العمل',
      details: ['الأحد - الخميس: 8:00 ص - 5:00 م']
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // تطهير البيانات المدخلة وحمايتها من الثغرات
    const name = validator.escape(validator.trim(formData.name));
    const emailRaw = validator.trim(formData.email);
    const email = validator.normalizeEmail(emailRaw);
    const phone = validator.escape(validator.trim(formData.phone));
    const subject = validator.escape(validator.trim(formData.subject));
    const message = validator.escape(validator.trim(formData.message));

    if (!email || !validator.isEmail(email)) {
      alert('يرجى إدخال بريد إلكتروني صالح.');
      setLoading(false);
      return;
    }

    if (name.length < 2 || message.length < 5) {
      alert('يرجى ملء جميع الحقول بشكل صحيح.');
      setLoading(false);
      return;
    }

    const { error } = await supabase
      .from('emails')
      .insert([{ name, email, phone, subject, message }]);

    setLoading(false);

    if (error) {
      console.error('Submission error:', error.message);
      alert('حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة لاحقاً.');
      return;
    }

    alert('تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <section id="contact" className="py-24 bg-slate-50 border-b border-slate-200" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* عنوان القسم */}
        <div 
          ref={ref}
          className={`text-center mb-20 transform transition-all duration-1000 ${
            inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4">
            اتصل <span className="text-indigo-950">بنا</span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-indigo-950 to-blue-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-base md:text-xl text-black max-w-3xl mx-auto leading-relaxed font-light">
            يسعدنا استقبال استفساراتكم القانونية وتقديم الدعم الوقائي والقضائي الذي يحمي مصالح أعمالكم.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          
          {/* الجانب الأيمن: بطاقات معلومات التواصل */}
          <div 
            className={`bg-white rounded-2xl border border-slate-100 shadow-md p-8 transform transition-all duration-1000 delay-200 ${
              inView ? 'translate-x-0 opacity-100' : 'translate-x-12 opacity-0'
            }`}
          >
            <h3 className="text-2xl font-bold text-slate-900 mb-8 border-r-4 border-indigo-950 pr-3">معلومات التواصل</h3>
            
            <div className="space-y-8">
              {contactInfo.map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="p-2.5 bg-slate-50 border border-slate-100 rounded-xl shrink-0 text-indigo-950">
                    {item.icon}
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1.5 text-base">{item.title}</h4>
                    {item.details.map((detail, i) => (
                      <p key={i} className="text-black text-sm md:text-base leading-relaxed font-light">{detail}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            
            {/* بطاقة الاتصال المباشر بالواتساب للتواصل السريع الفوري */}
            <div 
              onClick={() => window.open('https://wa.me/966595014100', '_blank')}  
              className="cursor-pointer mt-10 p-5 bg-gradient-to-br from-indigo-950 to-slate-900 border border-indigo-950/10 rounded-xl text-white hover:shadow-indigo-950/10 transition-all duration-300 group shadow-md"
            >
              <h4 className="font-bold text-white mb-2 group-hover:text-blue-200 transition-colors">طلب استشارة فورية</h4>
              <p className="text-slate-200 text-xs md:text-sm leading-relaxed font-light">
                بإمكانكم حجز موعد لتقييم قضيتكم أو مراجعة عقودكم مباشرة عبر تطبيق الواتساب للتواصل الرسمي والمباشر.
              </p>
            </div>
          </div>
          
          {/* الجانب الأيسر: نموذج إرسال الرسائل وبناء قاعدة البيانات */}
          <div 
            className={`lg:col-span-2 bg-white rounded-2xl border border-slate-100 shadow-md p-8 transform transition-all duration-1000 delay-400 ${
              inView ? 'translate-x-0 opacity-100' : '-translate-x-12 opacity-0'
            }`}
          >
            <h3 className="text-2xl font-bold text-slate-900 mb-8 border-r-4 border-indigo-950 pr-3">أرسل لنا رسالة</h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-black font-medium mb-2 text-sm">الاسم الكامل</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 transition-all duration-300 text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-slate-700 font-medium mb-2 text-sm">البريد الإلكتروني</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 transition-all duration-300 text-sm"
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-slate-700 font-medium mb-2 text-sm">رقم الجوال أو الهاتف</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 transition-all duration-300 text-sm text-left"
                    dir="ltr"
                  />
                </div>
                <div>
                  <label htmlFor="subject" className="block text-slate-700 font-medium mb-2 text-sm">موضوع الاستشارة</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 transition-all duration-300 text-sm"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="message" className="block text-slate-700 font-medium mb-2 text-sm">تفاصيل الرسالة أو القضية</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 transition-all duration-300 text-sm resize-none"
                ></textarea>
              </div>
              
              <div className="flex justify-start">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-indigo-950 hover:bg-indigo-900 text-white font-bold py-3.5 px-8 rounded-xl transition-all duration-300 inline-flex items-center justify-center gap-2 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed text-base shadow-md shadow-indigo-950/5 hover:shadow-indigo-950/20"
                >
                  <span>{loading ? 'جاري إرسال البيانات...' : 'إرسال الرسالة القانونية'}</span>
                  <Send className="h-4 w-4 transform rotate-180" />
                </button>
              </div>
            </form>
          </div>
        </div>
        
        {/* الخريطة التفاعلية للموقع الجغرافي للمكتب المهني بجدة بتنسيق يتناسب مع النقاء الفاتح */}
        <div 
          className={`mt-16 relative h-96 rounded-2xl overflow-hidden border border-slate-200 shadow-md transform transition-all duration-1000 delay-600 ${
            inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3709.7050163127906!2d39.137213300000006!3d21.597434600000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3dbf426e2ebf7%3A0x4b0b674c26d9de48!2z2LTYsdmD2Kkg2YbYp9i12LEg2KfZhNix2KfYrNit2Yog2Ygg2LHYp9mF2Yog2KfZhNmF2LfZitix2Yog2YTZhNmF2K3Yp9mF2KfYqQ!5e0!3m2!1sar!2ssa!4v1780385321121!5m2!1sar!2ssa" 
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="موقع شركة ناصر الراجحي ورامي المطيري للمحاماة"
          ></iframe>
        </div>
      </div>
    </section>
  );
};